import React, { useEffect, useRef, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import {
  GroupingPriceFunction,
  padWithZeros,
  RoundWithRoundingPlace,
  trans,
  validateInput,
  validateInputAsNumber,
} from "utils/helpers";
import { REGEX } from "utils/regex";
import "./style.scss";

interface TextboxPropsType {
  labelText?: string;
  required?: boolean;
  useEval?: boolean;
  maxLength?: number;
  minLength?: number;
  minHeight?: number;
  min?: number;
  max?: number;
  textboxName: string;
  textboxType:
    | "number"
    | "text"
    | "textarea"
    | "email"
    | "color"
    | "tel"
    | "mobile"
    | "userName"
    | "password"
    | "systemKey"
    | "formKey"
    | "nationalCode"
    | "birthCertNo"
    | "econNo"
    | "RegistryNumber"
    | "nationalIdentifier"
    | "PostalCode"
    | "format"
    | "unitCode"
    | "wareHouseCode"
    | "CodeFormat"
    | "Condition";
  defaultValue?: any;
  value?: any;
  ExtraDescription?: any;
  mode?: any;
  readonly?: boolean;
  Change?: (ans: any) => void;
  onChange?: (ans: any) => void;
  setValid?: (ans: any) => void;
  onBlurHandler?: (ans: any) => void;
  resetForm?: boolean;
  autoFocus?: boolean;
  placeholder?: string;
  recordedData?: any;
  addOnValue?: any;
  decimals?: any;
  useTrans?: boolean;
  UsepadWithZeros?: boolean;
  capsLock?: boolean;
  fixedLanguage?: "en" | "fa" | null;
  withLabel?: any;
  customClass?: any;
  letterCounter?: any;
  withChangeDir?: any;
  usePrevDefaultValue?: any;
  step?: any;
  asNumber?: boolean;
  sqlInjection?: boolean;
  customeStyle?: any;
  customValidation?:any
  withMsg?:boolean
  useOnInput?:boolean// just use for InputDetector
}
export const Textbox = React.memo(
  ({
    withLabel = true,
    useEval = true,
    fixedLanguage = null,
    UsepadWithZeros = false,
    decimals = null,
    capsLock = false,
    onBlurHandler,
    addOnValue,
    autoFocus,
    useTrans = true,
    recordedData,
    ExtraDescription,
    min,
    max,
    labelText,
    required,
    textboxType,
    minHeight,
    minLength = 0,
    maxLength = 900,
    textboxName,
    value,
    defaultValue = "",
    Change,
    onChange,
    mode,
    readonly = false,
    resetForm,
    setValid,
    placeholder,
    customClass,
    letterCounter,
    withChangeDir = false,
    usePrevDefaultValue = false,
    sqlInjection = true,
    step,
    customeStyle,
    customValidation=null,
    asNumber = false, //در صورتی که اینپوت با تایپ تکست همراه(،) برای جداسازی عدد ها نیاز داشته باشیم و بخواهیم به جز عدد کاراکتر دیگری قبول نکند.
    withMsg=true,
    useOnInput=false
  }: TextboxPropsType) => {
    const [TEXTBOX_VAL, setTEXTBOX_VAL] = useState(
      textboxType == "text" && defaultValue == 0
        ? defaultValue + ""
        : defaultValue
    );
    const maxLengthValue=textboxType=="number"? +maxLength<15?maxLength:15:maxLength
    const disabled = mode == "view" ? true : readonly ? true : false;
    let [regexMsgShow, setRegexMsgShow] = useState<boolean>(false);
    let [maxLengthMsgShow, setMaxLengthMsgShow] = useState<boolean>(false);
    let [minLengthMsgShow, setMinLengthMsgShow] = useState<boolean>(false);
    let [requiredMsgShow, setRequiredMsgShow] = useState<boolean>(false); // check and delete unnecessary state
    let [count, setCount] = useState(defaultValue ? defaultValue.length : 0);
    const inputRef = useRef<any>();

    function Checkrequired(event) {
      maxLengthCheck(event);
      minLengthCheck(event)
      if (event.target.value.length == 0 && required) {
        setRequiredMsgShow(true);
      }
      onBlurHandler && onBlurHandler(event.target.value);
      if (UsepadWithZeros && maxLengthValue) {
        setTEXTBOX_VAL(
          padWithZeros(maxLengthValue, event.target.value ? event.target.value : "")
        );
      }
      if (decimals != null && event.target.value) {
        setTEXTBOX_VAL(
          RoundWithRoundingPlace(
            +event.target.value.replaceAll(",", "")
              ? +event.target.value.replaceAll(",", "")
              : 0,
            decimals
          ) + ""
        );
      }
      // setTEXTBOX_VAL(event);
    }

    function checkRegexValidation(event) {
      const hasNewLine =
        event.target.value.includes("\n") || event.target.value.includes("\r"); //find enter key
      let newValue = event.target.value + "";
      if (hasNewLine) {
        // event.target.value=event.target.value.replace(/[\r\n]+/g, '')//remove enter key
      }
      setRequiredMsgShow(false);
      if (letterCounter) {
        setCount(event.target.value.length);
      }
      if (event.target.value != defaultValue) {
        Change &&
          Change({
            [textboxName]:
              event.target.value.length == 0 ? " " : event.target.value,
          });
      } else {
        Change && Change({ [textboxName]: null });
      }
      if (capsLock) {
        event.target.value = event.target.value.toUpperCase();
      }
      let valditaionRegex;
      let validationRegexResult;
      valditaionRegex = new RegExp(REGEX[textboxType].regex);
      validationRegexResult = valditaionRegex.test(event.target.value);

      if (!validationRegexResult ) {
        if( event.target.value.length > 0){
          event.target.setCustomValidity(REGEX[textboxType].valditionMsg);
          event.target.reportValidity();
          setRegexMsgShow(true);
        }
      } else if (validationRegexResult) {
        event.target.setCustomValidity("");
        setRegexMsgShow(false);
      }


if((customValidation && !customValidation(event.target.value)?.invalid) || !customValidation){
      if (
        (validateInput(event.target.value) && !asNumber) ||
        (validateInput(event.target.value) &&
          asNumber &&
          validateInputAsNumber(event.target.value))
      ) {
        if (
          newValue &&
          useEval &&
          newValue.endsWith("=") &&
          newValue.startsWith("=") &&
          newValue.length > 1
        ) {
          newValue = newValue.replaceAll("=", "");
          newValue = eval(newValue) + "";
          inputRef.current.value = newValue;
        }
        if (decimals != null && inputRef.current) {
          inputRef.current.value = RoundWithRoundingPlace(
           +newValue,
            decimals
          );
        }
        if (event.target.max && +newValue > +event.target.max) {
          event.target.setCustomValidity(
            trans("Msg_Validation_InvalidMaxLength") +`(${trans("maxlength") } : ${+event.target.max})`    
          );
          event.target.reportValidity();
          setTEXTBOX_VAL(value);
          onChange && onChange(event);
        }
        else if(event.target.min && +newValue < +event.target.min){
          event.target.setCustomValidity(
            trans("msg_validation_valueisincorrect")
          );
          event.target.reportValidity();

           setTEXTBOX_VAL( event.target?.value);
           onChange && onChange(event);
        }
        else {
      
          setTEXTBOX_VAL(
           newValue
          );
          onChange && onChange(event);
        }
      }
      else{
        if(!validateInput(event.target.value)&& sqlInjection){
          // onChange && onChange(event);
          if(!useOnInput){

            setRegexMsgShow(true)
            event.target.setCustomValidity(trans("Msg_Validation_InvalidCharacter"))
            event.target.reportValidity();
          }
          setTEXTBOX_VAL(
          newValue
          );
        }
      }
}else{
   setRegexMsgShow(true)
        event.target.setCustomValidity(trans(customValidation(event.target.value)?.message))
        event.target.reportValidity();
        setTEXTBOX_VAL(
       newValue
        );
}


  
    }
    function maxLengthCheck(e) {
      e.stopPropagation();
      if (maxLengthValue !== undefined && maxLengthValue) {
        if (TEXTBOX_VAL && TEXTBOX_VAL?.length >  maxLengthValue) {
          // چون ست کردن یوز استیت یک قدم عقب تر است شرط == جواب میدهد
          // e.target.setCustomValidity(trans("Msg_Validation_MaxCharacterLength").replace("{0}",maxLengthValue));
          e.target.reportValidity();
          e.target.setCustomValidity(' ')
          setMaxLengthMsgShow(true);
          // let id = setTimeout(() => {
          //   setMaxLengthMsgShow(false);
          // }, 2000); // هشدار حداکثر طول بعد از 3 ثانیه ناپدید می شود
        } else {
          if(maxLengthMsgShow)
            e.target.setCustomValidity("");
          setMaxLengthMsgShow(false);

        }
      }
    }
    
       function minLengthCheck(e) {        
       e.stopPropagation();
      if (minLength !== undefined && minLength) {
        if (TEXTBOX_VAL && TEXTBOX_VAL?.length <  minLength) {
          // چون ست کردن یوز استیت یک قدم عقب تر است شرط == جواب میدهد
          // e.target.setCustomValidity(trans("Msg_Validation_MinCharacterLength").replace("{0}",minLength));
          e.target.reportValidity();
          e.target.setCustomValidity(' ')
          setMinLengthMsgShow(true);
          // let id = setTimeout(() => {
          //   setMinLengthMsgShow(false);
          // }, 2000); // هشدار حداکثر طول بعد از 3 ثانیه ناپدید می شود
        } else {
          if(maxLengthMsgShow)
            e.target.setCustomValidity("");
          setMinLengthMsgShow(false);
        }
      }
    }
    useEffect(() => {
      if (UsepadWithZeros && maxLengthValue && defaultValue) {
        setTEXTBOX_VAL(padWithZeros(maxLengthValue, defaultValue));
      } else {
        if (decimals != null && defaultValue) {
          setTEXTBOX_VAL(RoundWithRoundingPlace(+defaultValue, decimals) + "");
        } else {
          setTEXTBOX_VAL(
            textboxType == "text" && defaultValue == 0
              ? defaultValue + ""
              : defaultValue
          );
        }
      }
    }, [defaultValue]);

    useEffect(() => {
      if (resetForm) setTEXTBOX_VAL(defaultValue);
    }, [resetForm]);

    useEffect(() => {
      if (usePrevDefaultValue) {
        setTEXTBOX_VAL(RoundWithRoundingPlace(+defaultValue, decimals) + "");
      }
    }, [usePrevDefaultValue]);

    useEffect(() => {
      window.addEventListener(
        "keydown",
        (e) => {
          const target = e.target as HTMLElement;
          if ( e.key === "Enter" && target.tagName !== "TEXTAREA") {
            e.preventDefault();
          }
          if(  e.ctrlKey && e.keyCode == 67 && document.activeElement ==e.target && document.activeElement?.tagName !="BODY"){
            //  e.stopPropagation()
          }
        }, 
        true
      );
      return () => {
        window.removeEventListener(
          "keydown",
          (e) => {
            if (e.key === "Enter") {
              e.preventDefault();
            }
          },
          true
        );
      };
    }, []);
    const textChange = (title) => {
      var regex = /[\u0600-\u06FF]+/;
      var numRegex = /\d+/g;

      let text = "";
      title?.split(" ").forEach((item: any, index) => {
        if (regex.test(item as any)) {
          text += item + " ";
        } else {
          text +=
            " " +
            '<div style="direction: ltr;unicodeBidi:unset;display:inline">' +
            item +
            "</div>" +
            " ";
        }
      });
      title = text;
      return title.replaceAll(/\d+/g, (i) => {
        return `<div style="direction: ltr;unicodeBidi:unset;display:inline">  ${i} </div>`;
      });
    };
    const handleKeyDown = (event) => {
      if (
        event.key !== "Backspace" &&
        event.key !== "Delete" &&
        event.key !== "ArrowLeft" &&
        event.key !== "ArrowRight" &&
        event.key !== "ArrowUp" &&
        event.key !== "ArrowDown" &&
        event.key !== "-" &&
        event.key !== "/" &&
        event.key !== "." &&
        !/^\d$/.test(event.key)
      ) {
        //event.preventDefault();
      }
    };
    return (
      <div className="text-box w-100">
        <div className="d-flex w-100 justify-content-between">
          {withLabel && (
            <OverlayTrigger
              key={labelText}
              placement="top"
              delay={{ show: 100, hide: 0 }}
              overlay={
                <Tooltip
                  className="tooltip"
                  id={`button-tooltip-${"checkable"}`}
                >
                  {trans(labelText + "")}
                </Tooltip>
              }
            >
              <div
                className="d-flex  align-items-center"
                style={{ height: "22px", width: "80%" }}
              >
                {labelText && (
                  <label className="text-box__label showDots">
                    {useTrans ? trans(labelText) : labelText}
                  </label>
                )}
                {required && labelText && (
                  <span className="text-box__required-sign-for-label text-danger">
                    *
                  </span>
                )}
              </div>
            </OverlayTrigger>
          )}
          {(ExtraDescription ||
            (mode == "edit" &&
              recordedData != undefined &&
              recordedData != TEXTBOX_VAL) ||
            (mode == "create" &&
              recordedData != TEXTBOX_VAL &&
              TEXTBOX_VAL != undefined &&
              TEXTBOX_VAL.length > 0 &&
              recordedData != undefined)) && (
            <>
              <OverlayTrigger
                key={"reserve"}
                placement="top"
                delay={{ show: 600, hide: 0 }}
                overlay={
                  <Tooltip
                    style={{ direction: "rtl" }}
                    className="tooltip "
                    id={`button-tooltip-${"reserve"}`}
                  >
                    {trans("PreviousValue") + " : " + recordedData}
                  </Tooltip>
                }
              >
                <span className="d-flex " style={{ maxWidth: "18%" }}>
                  <FontAwesomeIcon
                    style={{ marginRight: "5px" }}
                    icon={["fas", "circle-info"]}
                    className="text-primary pr-2"
                  />
                  {!ExtraDescription && (
                    <FontAwesomeIcon
                      onClick={() => {
                        setTEXTBOX_VAL(recordedData);
                        onChange && onChange({ recordedData });
                      }}
                      style={{ marginRight: "5px" }}
                      icon={["fas", "undo"]}
                      className="text-primary pr-2"
                    />
                  )}
                </span>
              </OverlayTrigger>
            </>
          )}
        </div>
        <OverlayTrigger
          key={labelText + " " + "value"}
          placement="top"
          offset={[5, 10]}
          delay={{ show: 100, hide: 0 }}
          overlay={
            mode == "view" &&
            TEXTBOX_VAL &&
            TEXTBOX_VAL?.length > 0 &&
            !ExtraDescription ? (
              <Tooltip className="tooltip" id={`button-tooltip-${labelText}`}>
                {TEXTBOX_VAL ? TEXTBOX_VAL : ""}
              </Tooltip>
            ) : (
              <></>
            )
          }
        >
          {textboxType === "textarea" ? (
            <textarea
              autoFocus={autoFocus}
              rows={minHeight ? minHeight : 2}
              onBlur={Checkrequired}
              name={textboxName}
              value={TEXTBOX_VAL ? TEXTBOX_VAL : ""}
              onMouseDown={(e) => e.stopPropagation()}
              className={`text-box__textarea form-control  ${
                required && " required-input"
              } `}
              onChange={checkRegexValidation}
              maxLength={maxLengthValue ? maxLengthValue : 900}
              required={required}
              disabled={disabled}
              placeholder={placeholder}
            ></textarea>
          ) : addOnValue ? (
            <div className="col-auto ms-1 row align-items-center">
              <div className="col ps-0">
                <input
                  ref={inputRef}
                  autoFocus={autoFocus}
                  id={textboxName + "Id"}
                  placeholder={placeholder}
                  min={min}
                  max={max}
                  step={step}
                  pattern={REGEX[textboxType].regex}
                  onKeyDown={(e) => {
                    e.stopPropagation();
                    if (textboxType == "number") {
                      handleKeyDown(e);
                    }
                  }}
                  onBlur={Checkrequired}
                  autoComplete="off"
                  name={textboxName}
                  onMouseDown={(e) => e.stopPropagation()}
                  value={
                    TEXTBOX_VAL
                      ?  TEXTBOX_VAL
                      : ""
                  }
                  type={textboxType}
                  className={`text-start text-box__box ${
                    textboxType == "number" ||
                    textboxType == "tel" 
               
                      ? " form-control NumberFontSize "
                      : "form-control"
                  }   ${required && " required-input"} ${
                    customClass ? customClass : ""
                  }`}
                  onChange={(e) => {
                    inputRef.current.focus();  
                    checkRegexValidation(e);
                  }}
                  onInput={useOnInput?(e) => {
                    checkRegexValidation(e);
                  }:()=>{}}
                  maxLength={maxLengthValue ? maxLengthValue : undefined}
                  minLength={minLength ? minLength : undefined}
                  required={required}
                  disabled={disabled}
                  style={{
            
                  borderRadius:'0px 5px 5px 0px',
                    direction:
                      textboxType == "email" ||
                      textboxType == "systemKey" ||
                      textboxType == "formKey" ||
                      // textboxType == "number" ||

                      fixedLanguage == "en" ||
                      labelText?.includes("EN")
                        ? "ltr"
                        : "unset",
                    ...customeStyle,
                  }}
                />
              </div>
              <div
                className="col-auto  text-end pt-1 "
                style={{
                  padding: "4px 8px",
                  border: "1px solid #ced4da",
                  borderRight: "0px",
                  borderRadius: "5px 0px 0px 5px",
               
                  backgroundColor: "#e9ecef",
                  height: "27.5px",
                }}
              >
                {addOnValue}
              </div>
            </div>
          ) : (
            <input
              ref={inputRef}
              autoFocus={autoFocus}
              id={textboxName + "Id"}
              placeholder={placeholder}
              min={min}
              max={max}
              step={step}
              pattern={REGEX[textboxType].regex}
              onKeyDown={(e) => {
                e.stopPropagation();
                if (textboxType == "number") {
                  handleKeyDown(e);
                }
              }}
              onWheel={(e:any)=>{
                if (textboxType == "number") {
                  e.target.blur()
                }
              }
              }
              onBlur={Checkrequired}
              autoComplete="off"
              name={textboxName}
              onMouseDown={(e) => e.stopPropagation()}
              value={
                TEXTBOX_VAL
                  ?  TEXTBOX_VAL
                  : ""
              }
              type={textboxType}
              className={` text-box__box ${
                textboxType == "number" ||
                textboxType == "tel" 
                  ? " form-control NumberFontSize "
                  : "form-control"
              }   ${required && " required-input"} ${
                customClass ? customClass : ""
              }`}
              onChange={(e) => {
                inputRef.current.focus();        
                checkRegexValidation(e);
              }}
              onInput={useOnInput?(e) => {
                checkRegexValidation(e);
              }:()=>{}}
              maxLength={maxLengthValue ? maxLengthValue : undefined}
              minLength={minLength ? minLength : undefined}
              required={required}
              disabled={disabled}
              style={{
                direction:
                  textboxType == "email" ||
                  textboxType == "systemKey" ||
                  textboxType == "formKey" ||
                  // textboxType == "number" ||

                  fixedLanguage == "en" ||
                  labelText?.includes("EN")
                    ? "ltr"
                    : "unset",
                ...customeStyle,
              }}
            />
          )}
        </OverlayTrigger>

      { withMsg ? <div className="text-box__msg-wrapper">
          {required && (
            <span
              className={`${
                requiredMsgShow ? "show-msg" : "hide-msg"
              } text-box__required-msg text-danger`}
            >
              {trans("Msg_Validation_ValueIsRequired", [""])}
            </span>
          )}

          {withChangeDir && (
            <span
              className={`text-dark show-msg text-box__required-msg `}
              dangerouslySetInnerHTML={{ __html: textChange(TEXTBOX_VAL) }}
            ></span>
          )}
          {letterCounter && (
            <span
              className={`${
                count === maxLengthValue ? "text-danger" : "text-dark"
              } show-msg text-box__required-msg `}
            >
              {count + "/" + maxLengthValue}&nbsp;{trans("character")}
            </span>
          )}

          <span
            className={`${
              regexMsgShow ? "show-msg" : "hide-msg"
            } text-box__regex-msg text-danger`}
          >
            {textboxType && TEXTBOX_VAL && TEXTBOX_VAL !== ""
              ? REGEX[textboxType].valditionMsg
              : null}
          </span>
          {maxLengthMsgShow ? (
            <span
              className={`${
                maxLengthMsgShow ? "show-msg" : "hide-msg"
              } text-box__max-length-msg text-danger`}
            >{`${trans("Msg_Validation_MaxCharacterLength").replace("{0}",maxLengthValue)}`}</span>
          ) :
          minLengthMsgShow?
          <span
              className={`${
                minLengthMsgShow ? "show-msg" : "hide-msg"
              } text-box__max-length-msg text-danger`}
            >{`${trans("Msg_Validation_MinCharacterLength").replace("{0}",minLength)}`}</span>
          
          :

          (
            <></>
          )}
        </div>:<></>}
      </div>
    );
  }
);
